export const getDashboardUserFullName = (dashboardUser) => {
  return dashboardUser ? (dashboardUser.firstName ? dashboardUser.lastName ? `${dashboardUser.firstName} ${dashboardUser.lastName}` : dashboardUser.firstName : dashboardUser.email) : 'unknown'
}
